import FilteredRestaurantCarouselCardSkeleton from './cardSkeleton';
import { CityCarouselSeeAll, RestaurantCarouselSkeleton } from './restaurantCarousel';

export type FilteredRestaurantsCarouselSkeletonProps = {
  heading: string;
  className?: string;
  id?: string;
  itemCount?: number;
};

export default function FilteredRestaurantsCarouselSkeleton({
  heading,
  ...props
}: FilteredRestaurantsCarouselSkeletonProps) {
  return (
    <RestaurantCarouselSkeleton
      {...props}
      heading={heading}
      seeAll={<CityCarouselSeeAll disabled />}
      renderCard={() => <FilteredRestaurantCarouselCardSkeleton />}
    />
  );
}
